import { cn, initials } from "@/lib/utils"

const SIZE_CLASS = {
  sm: "size-10 text-sm",
  md: "size-11 text-base",
  lg: "size-12 text-lg",
} as const

/**
 * The one image-or-initials mark for companies, people and hackathon hosts.
 * Renders `imageUrl` when present, otherwise uppercase initials on the lime
 * tile every job/company card uses.
 */
export function EntityMark({
  name,
  imageUrl,
  size = "md",
  shape = "rounded",
  letters = 1,
  tone = "accent",
  className,
}: {
  name: string
  imageUrl?: string | null
  size?: keyof typeof SIZE_CLASS
  shape?: "rounded" | "circle"
  /** 1 for company/host tiles, 2 for person avatars. */
  letters?: 1 | 2
  /** accent = lime tile; mute = grey tile for secondary entities. */
  tone?: "accent" | "mute"
  className?: string
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden font-extrabold",
        tone === "accent"
          ? "bg-[rgb(196_240_75/0.55)] text-[color:var(--wf-ink)]"
          : "bg-[rgb(12_15_20/0.06)] text-[color:var(--wf-mute)]",
        SIZE_CLASS[size],
        shape === "circle" ? "rounded-full" : "rounded-[0.4rem]",
        className,
      )}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="size-full object-cover" />
      ) : (
        initials(name, letters)
      )}
    </div>
  )
}
